// extracted by mini-css-extract-plugin
export default {"formItem":"ActivityValuesForm__formItem___R82kL"};